import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getProducts,
  deleteProduct,
  getNextProducts,
  getPreviousProducts,
} from "../../store/actions/products_action";
import { LIMIT } from "../../domain/constant";
import Pagination from "../../components/common/Pagination";
import Filters from "../../components/common/Filters";
import AddBtn from "../../components/common/AddBtn";
import { SEARCH_TERMS, view_all_table } from "../../shared/enums/products_enum";
import DataTable from "../../components/common/DataTable";
const AllProducts = ({
  getProducts,
  deleteProduct,
  getNextProducts,
  getPreviousProducts,
  product: { loading, products },
}) => {
  const [page, setPage] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await deleteProduct(deleteEntry);
      }
      getProducts({});
    }
    allQuery();
  }, [deleteEntry]);

  const nextButtonClicked = () => {
    if (products && products.length === LIMIT) {
      const lastProduct = products[products.length - 1];
      getNextProducts({ last: lastProduct });
      setPage(page + 1);
    }
  };
  const prevBtnClicked = () => {
    if (page > 1) {
      const lastProduct = products[0];
      getPreviousProducts({
        first: lastProduct,
      });
      setPage(page - 1);
    }
  };
  const filterClicked = () => {
    if (term && term.length > 0) {
      setPage(1);
      setQ(term);
      getProducts({ term: term, termField: termField });
    }
  };
  const deleteProductClicked = (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPage(1);
    setQ(null);
    setTerm("");
    getProducts({});
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Products"
          mainLinkTitle="Dashboard"
          mainLinkUrl="/dashboard"
          activeLink="Product"
        />

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="card"
                style={{ boxShadow: "rgb(227 233 243) 0px 4px 22px" }}
              >
                <div className="card-body">
                  <AddBtn item="products" title="Product" />
                  <hr />

                  <Filters
                    q={q}
                    resetFilter={resetFilter}
                    setTerm={setTerm}
                    term={term}
                    filterClicked={filterClicked}
                    termField={termField}
                    setTermField={setTermField}
                    all_terms={SEARCH_TERMS}
                  />
                  <hr />
                  <div>
                    <DataTable
                      keys={view_all_table}
                      data={products}
                      field={"products"}
                      page={page}
                      deleteBtnClicked={deleteProductClicked}
                      loading={loading}
                    />
                    <Pagination
                      data={products}
                      page={page}
                      prevBtnClicked={prevBtnClicked}
                      nextButtonClicked={nextButtonClicked}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ product: state.product });

const mapDispatchToProps = {
  getProducts,
  deleteProduct,
  getNextProducts,
  getPreviousProducts,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllProducts);
